module.exports = __webpack_public_path__ + "img/TV_clean_box01.f104dac8.jpg";